import getVoyagerPagemakerTemplate from '@ibibo/get-voyager-pagemaker-template';
import {setToInMemory, getFromInMemory} from '@ibibo/server-shared-inmemory-cache';

export async function setHomeSeoMetaToInMemory(templates, sync = false) {
  const data = await getVoyagerPagemakerTemplate({templates});
  if (data) {
    templates.forEach((template, index) => {
      setToInMemory(template, data[index], sync);
    });
  }
  return data;
}

export const getHomeSeoMetaFromInmemory = getFromInMemory;

export async function purgeHomeSeoMetaData(request, response, next) {
  const {template} = request.params;
  const data = await setHomeSeoMetaToInMemory([template], true);
  response.send(data);
}
